import { DownOutlined, UpOutlined } from '@ant-design/icons';

interface Props {
  title: string;
  sort: boolean;
  setSort: (status: any) => void;
}

const TableSort = ({ title, sort, setSort }: Props) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      {title}
      {!sort ? (
        <DownOutlined
          style={{ marginLeft: '1rem' }}
          onClick={() => {
            setSort(true);
          }}
        />
      ) : (
        <UpOutlined
          style={{ marginLeft: '1rem' }}
          onClick={() => setSort(false)}
        />
      )}
    </div>
  );
};

export default TableSort;
